export enum HttpStatusEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    UNDEFINED = 'UNDEFINED',
    LIMS_ISSUES = 'LIMS_ISSUES',
    LOGIN_REQUIRED = 'LOGIN_REQUIRED',
}
